import { useNavigate } from "react-router";

export function Header() {
    const navigate = useNavigate();
    return (
        <section className="flex flex-col md:flex-row justify-between items-start md:items-center gap-y-4">
            <div className="flex flex-col gap-y-2">
                <h1 className="text-gray-900 dark:text-gray-100 font-bold text-2xl">Talent</h1>
                <p className="w-full md:w-4/5 text-gray-600 dark:text-gray-400 font-normal text-sm">Explore our community of local students ready to assist with AI, marketing, design, and more. Find the right person for your project and get the conversation started.</p>
            </div>
            <div className="flex-shrink-0 w-full md:w-auto">
                <button type="button" onClick={() => navigate("/jobpost")} className="px-4 h-10 w-full md:w-auto text-white font-semibold text-sm bg-blue-700 hover:bg-blue-500 rounded-lg">
                    Post an Opportunity
                </button>
            </div>
        </section>
    );
}